import { PropertyMgmtComp } from '../models/property-management'

export const mockPropertyMgmtComps = [
  { id: 1, name: 'Lan Phan Property' },
  { id: 2, name: 'Jimmy Property' },
  { id: 3, name: 'Suleman Property' },
] as PropertyMgmtComp[]
